// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","396":"e4aad8f3","455":"d639c004","857":"44f4b707","977":"3e68c99d"}[chunkId] + ".chunk.js";
};